import { Flex, PrimarySecondaryPage, Spinner } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "@wayflyer/api-types";
import { Suspense } from "react";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router";
import { getPlatformStringFromConnectionCategory } from "shared-ui";

import { ReconnectConnection } from "../../../components/additional-information-requests";
import { ReconnectConnectionsSecondaryContent } from "../../../components/additional-information-requests/reconnect-connection/reconnect-connections-secondary-content";

export const ReconnectConnectionPage = ({
  air,
  onBack,
}: {
  air: FundingApplicationSchemas.AIRSchema;
  onBack: () => void;
}) => {
  const intl = useIntl();
  const airData = air.air_data?.data as FundingApplicationSchemas.ReconnectConnectionAIRSchema;

  const [searchParams] = useSearchParams();
  const currentReconnectStep = searchParams.get("step");

  const title = (() => {
    switch (currentReconnectStep) {
      case "upload_bank_statements":
        return intl.formatMessage({
          id: "funding-application: air reconnect connection banking upload statements title",
          defaultMessage: "Bank statements required",
        });
      case "cannot_reconnect_bank":
      case "cannot_reconnect_connection":
        return intl.formatMessage(
          {
            id: "funding-application: air reconnect connection cannot reconnect title",
            defaultMessage: "Can't reconnect your {platformType}",
          },
          {
            platformType: getPlatformStringFromConnectionCategory(
              intl,
              airData.connection_meta_data?.type,
              airData.connection_type
            ),
          }
        );
      default:
        return intl.formatMessage(
          {
            id: "funding-application: air reconnect connection default title",
            defaultMessage: "Reconnect your {platformType}",
          },
          {
            platformType: getPlatformStringFromConnectionCategory(
              intl,
              airData.connection_meta_data?.type,
              airData.connection_type
            ),
          }
        );
    }
  })();

  return (
    air.air_data && (
      <PrimarySecondaryPage
        titleWrap="wrap"
        title={title}
        primaryContent={
          // Suspense boundary here to prevent parent from mounting (showing sidebar) and this component and hitting suspense in ReconnectConnection
          <Suspense
            fallback={
              <Flex justify="center" width="100%">
                <Spinner size={32} />
              </Flex>
            }
          >
            <ReconnectConnection
              airPublicId={air.air_data.public_identifier}
              airData={air.air_data.data as FundingApplicationSchemas.ReconnectConnectionAIRSchema}
              onBack={onBack}
            />
          </Suspense>
        }
        secondaryContent={<ReconnectConnectionsSecondaryContent />}
      />
    )
  );
};
